export const TRANSITION_SECONDS = 2.2;

const ramp = (time, start, end) => {
  const t = Math.max(0, Math.min(1, (time - start) / (end - start)));
  return t * t * (3 - 2 * t);
};

export function transitionTimeline(time) {
  const recede = ramp(time, 1.12, TRANSITION_SECONDS);
  const neutral = ramp(time, .4, 1.1);
  const colors = [[255, 85, 77], [255, 132, 103], [255, 184, 139], [255, 225, 195], [247, 251, 255]];
  const colorPosition = neutral * (colors.length - 1);
  const index = Math.min(colors.length - 2, Math.floor(colorPosition));
  const blend = colorPosition - index;
  const color = colors[index].map((value, channel) =>
    value + (colors[index + 1][channel] - value) * blend);
  return {
    charge: ramp(time, 0, .85),
    neutral,
    color,
    spread: ramp(time, .2, 1.12),
    coverage: ramp(time, .65, 1.12),
    sweep: 0,
    release: ramp(time, .35, .95),
    light: ramp(time, .1, .7) * (1 - ramp(time, 1.12, 1.92)),
    recede,
    aperture: Math.max(.22, (1 - recede) ** 3),
    dissolve: ramp(time, 1.42, 1.92),
    diffusion: ramp(time, 1.12, 1.92),
    dark: 0,
    selectorReady: time >= 1,
    handedOff: time >= TRANSITION_SECONDS,
    phase: time < .2 ? "ignition" : time < 1.18 ? "transport"
      : "reveal",
  };
}
